import type { ProLayoutProps } from '@ant-design/pro-components';
import tinycolor from 'tinycolor2';

/**
 * 动态生成 Layout 配置
 * @param colorPrimary 当前主题色
 */
const getSettings = (
  colorPrimary: string = '#00A870',
): ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} => {
  const originalColor = tinycolor(colorPrimary);
  const darkenedColor1 = originalColor.darken(10).toHexString();
   

  return {
    navTheme: 'light',
    colorPrimary: colorPrimary,
    // layout: 'mix',
    layout:'side',
    contentWidth: 'Fluid',
    fixedHeader: true,
    fixSiderbar: true,
    colorWeak: false,
    title: '环境足迹分析系统',
    pwa: false,
    logo: '/logo.png',
    iconfontUrl: '',
    desc: '环境足迹分析系统',
   
    siderWidth: 240,
    token: {
      bgLayout: '#f5f5f5',
      sider: {
        colorMenuBackground: '#fff',
        colorTextMenu: 'black',
        colorTextMenuSelected: '#fff',
        colorTextMenuActive: 'black',
        colorTextMenuItemHover: 'black',
        colorBgMenuItemActive: colorPrimary,
        colorBgMenuItemHover: '#E6F7F1',
        colorBgMenuItemSelected: colorPrimary,
      },
      header: {
        colorBgHeader: colorPrimary,
        colorHeaderTitle: '#fff',
      },
    },
  };
};

// // 默认导出
export default getSettings();
export { getSettings };
